import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import HomeOutlined from "@mui/icons-material/HomeOutlined";
import AppsOutlined from "@mui/icons-material/AppsOutlined";
import AdminPanelSettingsOutlined from "@mui/icons-material/AdminPanelSettingsOutlined";

import ContactsOutlined from "@mui/icons-material/ContactsOutlined";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import FavoriteBorderOutlined from "@mui/icons-material/FavoriteBorderOutlined";
import PersonOutlineOutlined from "@mui/icons-material/PersonOutlineOutlined";
import TimelineOutlined from "@mui/icons-material/TimelineOutlined";
import InsightsOutlined from "@mui/icons-material/InsightsOutlined";
import MonitorHeartOutlined from "@mui/icons-material/MonitorHeartOutlined";

import GroupOutlined from "@mui/icons-material/GroupOutlined";
import ConfirmationNumberOutlined from "@mui/icons-material/ConfirmationNumberOutlined";
import EventOutlined from "@mui/icons-material/EventOutlined";
import AssignmentTurnedInOutlined from "@mui/icons-material/AssignmentTurnedInOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";

import WorkOutlineOutlined from "@mui/icons-material/WorkOutlineOutlined";
import PersonAddAltOutlined from "@mui/icons-material/PersonAddAltOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";

import AttachMoneyOutlined from "@mui/icons-material/AttachMoneyOutlined";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";

import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import SupportAgentOutlined from "@mui/icons-material/SupportAgentOutlined";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import { Link } from "react-router-dom";
import { HelpOutline } from "@mui/icons-material";

import { FaTicketAlt, FaUserTie } from "react-icons/fa";
import { MdOutlinePolicy } from "react-icons/md";
import { TbArrowBigUpLines } from "react-icons/tb";
const Sidebar = () => {
  const [open, setOpen] = useState({});

  const toggle = (key) => {
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const SectionTitle = ({ title }) => (
    <div className="text-muted small fw-bold ps-3">{title}</div>
  );

  const Item = ({ icon, label, badge, sub }) => (
    <div
      className={`d-flex justify-content-between align-items-center ${sub ? "ps-2" : "ps-4"} py-2`}
    >
      <span className="d-flex align-items-center gap-2 small">
        {icon}
        {label}
      </span>
      {badge && <span className="badge bg-danger">{badge}</span>}
    </div>
  );

  const ToggleItem = ({ icon, label, stateKey, children, badge }) => {
    const isOpen = open[stateKey];

    return (
      <>
        <div
          onClick={() => toggle(stateKey)}
          className={`d-flex justify-content-between align-items-center ps-4 py-2 rounded 
        ${isOpen ? "bg-light" : ""}`}
          style={{
            transition: "opacity 1s ease",
          }}
        >
          <span className="d-flex align-items-center gap-2">
            {icon}
            {label}
            {badge && <span className="badge bg-danger">{badge}</span>}
          </span>

          {isOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </div>

        {isOpen && (
          <div className="ps-0 border-start ms-4 mb-2">
            {React.Children.map(children, (child) =>
              React.cloneElement(child, { sub: true }),
            )}
          </div>
        )}
      </>
    );
  };

  return (
    <div
      className="vh-100 border-end d-flex flex-column"
      style={{ width: 260 }}
    >
      <Link to="/">
        <div className="p-3 text-center">
          <img src="/assets/img/logo-1.svg" height="35" />
        </div>
      </Link>

      <div className="flex-grow-1 overflow-auto">
        <SectionTitle title="MAIN MENU" />

        <ToggleItem
          icon={<HomeOutlined fontSize="small" />}
          label="Dashboard"
          stateKey="dashboard"
          badge="Hot"
        >
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <Item
              icon={<AdminPanelSettingsOutlined fontSize="small" />}
              label="Admin Dashboard"
            />
          </Link>

          <Link
            to="/employee-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<GroupOutlined fontSize="small" />}
              label="Employee Dashboard"
            />
          </Link>

          <Link
            to="/deals-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<FavoriteBorderOutlined fontSize="small" />}
              label="Deals Dashboard"
            />
          </Link>

          <Link
            to="/leads-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<PersonOutlineOutlined fontSize="small" />}
              label="Leads Dashboard"
            />
          </Link>

          <Link
            to="/hr-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<InsightsOutlined fontSize="small" />}
              label="HR Dashboard"
              badge="New"
            />
          </Link>

          <Link
            to="/payroll-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<AttachMoneyOutlined fontSize="small" />}
              label="Payroll Dashboard"
              badge="New"
            />
          </Link>

          <Link
            to="/recruitment-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<WorkOutlineOutlined fontSize="small" />}
              label="Recruitment Dashboard"
              badge="New"
            />
          </Link>

          <Link
            to="/attendance-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<AssignmentTurnedInOutlined fontSize="small" />}
              label="Attendance Dashboard"
              badge="New"
            />
          </Link>

          <Link
            to="/financial-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<AccountBalanceOutlined fontSize="small" />}
              label="Finance Dashboard"
              badge="New"
            />
          </Link>

          <Link
            to="/it-admin-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<SettingsOutlined fontSize="small" />}
              label="IT Admin Dashboard"
              badge="New"
            />
          </Link>

          {/* <Link
            to="/asset-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<Inventory2Outlined fontSize="small" />}
              label="Asset Dashboard"
              badge="New"
            />
          </Link> */}

          <Link
            to="/helpdesk-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<SupportAgentOutlined fontSize="small" />}
              label="Help Desk Dashboard"
              badge="New"
            />
          </Link>
        </ToggleItem>

        <ToggleItem
          icon={<AppsOutlined fontSize="small" />}
          label="Applications"
          stateKey="apps"
        >
          <Link
            to="/chats-page"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<SupportAgentOutlined fontSize="small" />}
              label="Chat"
            />
          </Link>

          <Link
            to="/calendar-page"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item icon={<EventOutlined fontSize="small" />} label="Calendar" />
          </Link>
          <Link
            to="/emails-page"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<DescriptionOutlined fontSize="small" />}
              label="Email"
            />
          </Link>

          {/* <Item icon={<DescriptionOutlined fontSize="small" />} label="Notes" /> */}

          <Link
            to="/kanban-page"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item icon={<TimelineOutlined fontSize="small" />} label="Kanban" />
          </Link>
        </ToggleItem>

        <ToggleItem
          icon={<AdminPanelSettingsOutlined fontSize="small" />}
          label="Super Admin"
          stateKey="admin"
        >
          <Link
            to="/superadmin-dashboard"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Item
              icon={<BusinessOutlined fontSize="small" />}
              label="Dashboard"
            />
          </Link>

          <Link
            style={{ textDecoration: "none", color: "inherit" }}
            to="/companies-button"
          >
            <Item
              icon={<BusinessOutlined fontSize="small" />}
              label="Companies"
            />
          </Link>

          <Link
            style={{ textDecoration: "none", color: "inherit" }}
            to="/subscription-Page"
          >
            <Item
              icon={<AttachMoneyOutlined fontSize="small" />}
              label="Subscriptions"
            />
          </Link>

          <Link
            style={{ textDecoration: "none", color: "inherit" }}
            to="/packages-pages"
          >
            <Item
              icon={<Inventory2Outlined fontSize="small" />}
              label="Packages"
            />
          </Link>

          <Link
            style={{ textDecoration: "none", color: "inherit" }}
            to="/domain-page"
          >
            <Item icon={<SettingsOutlined fontSize="small" />} label="Domain" />
          </Link>
          {/*
           <Link  style={{ textDecoration: "none", color: "inherit" }} to="/domain-page"   >
              <Item icon={<SettingsOutlined fontSize="small" />} label="Purchse Transactions" />
        
        </Link>
           <Link  style={{ textDecoration: "none", color: "inherit" }} to="/domain-page"   >
              <Item icon={<SettingsOutlined fontSize="small" />} label="Tenat Usage Method" />
        
        </Link>
           <Link  style={{ textDecoration: "none", color: "inherit" }} to="/domain-page"   >
              <Item icon={<SettingsOutlined fontSize="small" />} label="Domain" />
        
        </Link> */}

          <ToggleItem
            icon={<FaTicketAlt size={16} />}
            label="Tickets"
            stateKey="admin"
          >
            <Link
              style={{ textDecoration: "none", color: "inherit" }}
              to="/agent-page"
            >
              <Item icon={<FaUserTie size={16} />} label="Agents" />
            </Link>

            <Link
              style={{ textDecoration: "none", color: "inherit" }}
              to="/sla-policies-page"
            >
              <Item icon={<MdOutlinePolicy size={16} />} label="SLA Policies" />
            </Link>

            <Link
              style={{ textDecoration: "none", color: "inherit" }}
              to="/escalations-rules-page"
            >
              <Item
                icon={<TbArrowBigUpLines size={16} />}
                label="Escalations Rules"
              />
            </Link>
          </ToggleItem>
        </ToggleItem>

        <SectionTitle title="CRM" />
        <Link to="/contact-list" className="text-decoration-none text-dark">
          <Item icon={<ContactsOutlined fontSize="small" />} label="Contacts" />
        </Link>

        <Link to="/companies-list" className="text-decoration-none text-dark">
          <Item
            icon={<BusinessOutlined fontSize="small" />}
            label="Companies"
          />
        </Link>

        <Link to="/deals-list" className="text-decoration-none text-dark">
          <Item
            icon={<FavoriteBorderOutlined fontSize="small" />}
            label="Deals"
          />
        </Link>

        <Link to="/leads-list" className="text-decoration-none text-dark">
          <Item
            icon={<PersonOutlineOutlined fontSize="small" />}
            label="Leads"
          />
        </Link>

        <Link to="/pipeline" className="text-decoration-none text-dark">
          <Item icon={<TimelineOutlined fontSize="small" />} label="Pipeline" />
        </Link>

        {/* <Link to="/analytics" className="text-decoration-none text-dark">
  <Item icon={<InsightsOutlined fontSize="small" />} label="Analytics" />
</Link> */}

        <Link to="/activity" className="text-decoration-none text-dark">
          <Item
            icon={<MonitorHeartOutlined fontSize="small" />}
            label="Activities"
          />
        </Link>

        <SectionTitle title="HRM" />

        <ToggleItem
          icon={<GroupOutlined fontSize="small" />}
          label="Employees"
          stateKey="employees"
        >
          {/* Employee Lists */}
          <Link to="/employee-lists" className="text-decoration-none text-dark">
            <Item
              icon={<GroupOutlined fontSize="small" />}
              label="Employee Lists"
            />
          </Link>

          {/* Employee Grid */}
          <Link to="/employee-grid" className="text-decoration-none text-dark">
            <Item
              icon={<AppsOutlined fontSize="small" />}
              label="Employee Grid"
            />
          </Link>

          {/* Employee Details */}
          <Link
            to="/employee-details"
            className="text-decoration-none text-dark"
          >
            <Item
              icon={<PersonOutlineOutlined fontSize="small" />}
              label="Employee Details"
            />
          </Link>

          {/* Departments */}
          <Link to="/departments" className="text-decoration-none text-dark">
            <Item
              icon={<BusinessOutlined fontSize="small" />}
              label="Departments"
            />
          </Link>

          {/* Designations */}
          <Link to="/designations" className="text-decoration-none text-dark">
            <Item
              icon={<WorkOutlineOutlined fontSize="small" />}
              label="Designations"
            />
          </Link>
        </ToggleItem>

<ToggleItem
  icon={<ConfirmationNumberOutlined fontSize="small" />}
  label="Tickets"
  stateKey="tickets"
>
  <Link to="/tickets-list" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<ConfirmationNumberOutlined fontSize="small" />}
      label="Tickets"
    />
  </Link>

  <Link to="/ticket-details" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<DescriptionOutlined fontSize="small" />}
      label="Ticket Details"
    />
  </Link>

  <Link to="/ticket-automation" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<SettingsOutlined fontSize="small" />}
      label="Ticket Automation"
      badge="New"
    />
  </Link>

  <Link to="/ticket-reports" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<InsightsOutlined fontSize="small" />}
      label="Ticket Reports"
      badge="New"
    />
  </Link>
</ToggleItem>
        <Link
          style={{ textDecoration: "none", color: "inherit" }}
          to="/holidays"
        >
          <Item icon={<EventOutlined fontSize="small" />} label="Holidays" />
        </Link>

        <ToggleItem
          icon={<AssignmentTurnedInOutlined fontSize="small" />}
          label="Attendance"
          stateKey="attendance"
        >
          <Item icon={<EventOutlined fontSize="small" />} label="Leaves" />
          <Item
            icon={<GroupOutlined fontSize="small" />}
            label="Attendance (Admin)"
          />
          <Item
            icon={<PersonOutlineOutlined fontSize="small" />}
            label="Attendance (Employee)"
          />
          {/* <Item
            icon={<TimelineOutlined fontSize="small" />}
            label="Timesheets"
          />
          <Item
            icon={<EventOutlined fontSize="small" />}
            label="Shift & Schedule"
          />
          <Item
            icon={<SupportAgentOutlined fontSize="small" />}
            label="Shift Swap Requests"
            badge="New"
          /> */}
        </ToggleItem>

        <ToggleItem
          icon={<InsightsOutlined fontSize="small" />}
          label="Performance"
          stateKey="performance"
        >
          <Item
            icon={<InsightsOutlined fontSize="small" />}
            label="Performance Indicator"
          />
          <Item
            icon={<DescriptionOutlined fontSize="small" />}
            label="Performance Review"
          />
          <Item
            icon={<AssignmentTurnedInOutlined fontSize="small" />}
            label="Performance Appraisal"
          />
          <Item
            icon={<TimelineOutlined fontSize="small" />}
            label="Goal List"
          />
        </ToggleItem>

        <ToggleItem
          icon={<SchoolOutlined fontSize="small" />}
          label="Training"
          stateKey="training"
        >
          <Item
            icon={<SchoolOutlined fontSize="small" />}
            label="Training List"
          />
          <Item icon={<GroupOutlined fontSize="small" />} label="Trainers" />
          <Item
            icon={<AppsOutlined fontSize="small" />}
            label="Training Type"
          />
          <Item
            icon={<AssignmentTurnedInOutlined fontSize="small" />}
            label="Certification Tracking"
            badge="New"
          />
        </ToggleItem>

        {/* <Item
          icon={<WorkOutlineOutlined fontSize="small" />}
          label="Probation Management"
          badge="New"
        /> */}
        <Item
          icon={<TimelineOutlined fontSize="small" />}
          label="Notice Period Tracker"
          badge="New"
        />
        {/* <Item
          icon={<WorkOutlineOutlined fontSize="small" />}
          label="Promotion"
        /> */}

        <Link
          style={{ textDecoration: "none", color: "inherit" }}
          to="/resignation"
        >
          <Item
            resignation
            icon={<PersonOutlineOutlined fontSize="small" />}
            label="Resignation"
          />
        </Link>

        <Link
          style={{ textDecoration: "none", color: "inherit" }}
          to="/termination"
        >
          <Item
            icon={<PersonOutlineOutlined fontSize="small" />}
            label="Termination"
          />{" "}
        </Link>
<SectionTitle title="RECRUITMENT" />

<Link to="/jobs" style={{ textDecoration: "none", color: "inherit" }}>
  <Item icon={<WorkOutlineOutlined fontSize="small" />} label="Jobs" />
</Link>

<Link to="/candidates" style={{ textDecoration: "none", color: "inherit" }}>
  <Item
    icon={<PersonAddAltOutlined fontSize="small" />}
    label="Candidates"
  />
</Link>

{/* Optional */}
{/* 
<Link to="/referrals" style={{ textDecoration: "none", color: "inherit" }}>
  <Item
    icon={<PersonAddAltOutlined fontSize="small" />}
    label="Referrals"
  />
</Link>
*/}

<Link to="/resume-parsing" style={{ textDecoration: "none", color: "inherit" }}>
  <Item
    icon={<DescriptionOutlined fontSize="small" />}
    label="Resume Parsing"
    badge="New"
  />
</Link>

<Link to="/campus-hiring" style={{ textDecoration: "none", color: "inherit" }}>
  <Item
    icon={<SchoolOutlined fontSize="small" />}
    label="Campus Hiring"
    badge="New"
  />
</Link>

{/* <Link to="/termination" style={{ textDecoration: "none", color: "inherit" }}>
  <Item
    icon={<PersonOutlineOutlined fontSize="small" />}
    label="Termination"
  />
</Link> */}
      <SectionTitle title="FINANCE & ACCOUNTS" />

<ToggleItem
  icon={<AttachMoneyOutlined fontSize="small" />}
  label="Sales"
  stateKey="sales"
>
  <Link to="/estimates" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<DescriptionOutlined fontSize="small" />}
      label="Estimates"
    />
  </Link>

  <Link to="/invoices" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<DescriptionOutlined fontSize="small" />}
      label="Invoices"
    />
  </Link>

  <Link to="/payments" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<AttachMoneyOutlined fontSize="small" />}
      label="Payments"
    />
  </Link>
</ToggleItem>

<ToggleItem
  icon={<AccountBalanceOutlined fontSize="small" />}
  label="Accounting"
  stateKey="accounting"
>
  <Link to="/categories" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<Inventory2Outlined fontSize="small" />}
      label="Categories"
    />
  </Link>

  <Link to="/budgets" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<AttachMoneyOutlined fontSize="small" />}
      label="Budgets"
    />
  </Link>
</ToggleItem>

<ToggleItem
  icon={<AttachMoneyOutlined fontSize="small" />}
  label="Payroll"
  stateKey="payroll"
>
  <Link
    to="/employee-salary"
    style={{ textDecoration: "none", color: "inherit" }}
  >
    <Item
      icon={<GroupOutlined fontSize="small" />}
      label="Employee Salary"
    />
  </Link>

  <Link to="/payslip" style={{ textDecoration: "none", color: "inherit" }}>
    <Item
      icon={<DescriptionOutlined fontSize="small" />}
      label="Payslip"
    />
  </Link>
</ToggleItem>
        <SectionTitle title="ADMINISTRATION" />

        <ToggleItem
          icon={<Inventory2Outlined fontSize="small" />}
          label="Assets"
          stateKey="assets"
        >
          <Item icon={<Inventory2Outlined fontSize="small" />} label="Assets" />
          <Item
            icon={<AppsOutlined fontSize="small" />}
            label="Asset Categories"
          />
        </ToggleItem>

        <ToggleItem
          icon={<SupportAgentOutlined fontSize="small" />}
          label="Help & Supports"
          stateKey="help"
        >
          <Item
            icon={<DescriptionOutlined fontSize="small" />}
            label="Knowledge Base"
          />
          <Item
            icon={<MonitorHeartOutlined fontSize="small" />}
            label="Activities"
          />
        </ToggleItem>

        <ToggleItem
          icon={<GroupOutlined fontSize="small" />}
          label="User Management"
          stateKey="users"
        >
          <Item icon={<GroupOutlined fontSize="small" />} label="Users" />
          <Item
            icon={<AdminPanelSettingsOutlined fontSize="small" />}
            label="Roles & Permissions"
          />
        </ToggleItem>

        <ToggleItem
          icon={<InsightsOutlined fontSize="small" />}
          label="Reports"
          stateKey="reports"
        >
          <Item
            icon={<AttachMoneyOutlined fontSize="small" />}
            label="Expense Report"
          />
          <Item
            icon={<DescriptionOutlined fontSize="small" />}
            label="Invoice Report"
          />
        </ToggleItem>

        <Link to="/settings" className="text-decoration-none text-dark">
          <ToggleItem
            icon={<SettingsOutlined fontSize="small" />}
            label="Settings"
            stateKey="settings"
          >
            <Item
              icon={<SettingsOutlined fontSize="small" />}
              label="General Settings"
            />
            <Item
              icon={<DescriptionOutlined fontSize="small" />}
              label="Email Settings"
            />
          </ToggleItem>
        </Link>

        <Link to="/terms-conditions" className="text-decoration-none text-dark">
          <Item
            icon={
              <DescriptionOutlined
                style={{ textDecoration: "none", color: "inherit" }}
              />
            }
            label="Terms & Conditions"
          />
        </Link>

        <Link to="/faq" className="text-decoration-none text-dark">
          <Item
            icon={
              <HelpOutline
                style={{ textDecoration: "none", color: "inherit" }}
              />
            }
            label="FAQ’S"
          />
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;
